import { connect } from 'react-redux';
import SpendingTypeCrear from './SpendingTypeCrear';
import { actions } from '../../../redux/modules/spendingType';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.spending_type,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(SpendingTypeCrear);
